import { confirmReadingRequestActionTypes, UpdateDocumentAdditionalData } from "../../documents";
import { Document, UserReadConfirmItems } from "../../../..";
import { FetchErrorInfo, SuccessFetchingAction, ErrorFetchingAction, FetchRequestActions } from "../../../../utils";
import { fetchReadConfirmActionTypes, FetchUserReadConfirmAction } from "./actions";

export interface ReadConfirmState {
    isFetching: boolean
    isUpdating: boolean
    data: UserReadConfirmItems
    fetchError?: FetchErrorInfo
    updateError?: FetchErrorInfo
}

export const initialReadConfirmState: ReadConfirmState = {
    data: [],
    isFetching: false,
    isUpdating: false
}

export const readConfirmReducer = (state: ReadConfirmState = initialReadConfirmState, action: FetchUserReadConfirmAction | FetchRequestActions<Document, UpdateDocumentAdditionalData>): ReadConfirmState => {
    switch (action.type) {
        case fetchReadConfirmActionTypes.start: {
            return {
                ...state,
                isFetching: true
            }
        }
        case fetchReadConfirmActionTypes.success: {
            const successAction = action as SuccessFetchingAction<UserReadConfirmItems>
            const newState: ReadConfirmState = {
                ...state,
                isFetching: false,
            }
            newState.data = successAction.result
            return {
                ...newState
            }
        }
        case fetchReadConfirmActionTypes.error: {
            const errorAction = action as ErrorFetchingAction
            return {
                ...state,
                isFetching: false,
                fetchError: errorAction.error
            }
        }
        case confirmReadingRequestActionTypes.success: {
            const {result: {docId}} = action as SuccessFetchingAction<Document, UpdateDocumentAdditionalData>
            return {
                ...state,
                data: state.data.filter(val => val !== docId)
            }
        }
        default:
            return state
    }
}